module.exports = __webpack_public_path__ + "static/pic02-b659503ea9734abd9779dee2e74a1c47.jpg";